import React from "react";
import { team1, team2 } from "../images/image";

export const Partidos = () => {
  return (
    <div className="partidos-ct max-width">
      <div className="partidos-ct-cards mw-ct">
        <h2>PARTIDOS</h2>
        <div className="wr-cg-4 cards">
          <div className="partidos-card">
            <p className="team-text">PRIMER EQUIPO</p>
            <p className="date-text">SÁBADO 26 AGO</p>
            <div className="team-logos">
              <img src={team1} alt="PSG" className="log1" />
              <img src={team2} alt="PSG" className="log2" />
            </div>
            <h2>
              PARIS <span>VS</span> LENS
            </h2>
            <div className="score">
              <div className="match-1">3</div>
              <div className="match-2">1</div>
            </div>
            <div className="team-text-link">
              <a href="/" className="link">
                VER CENTRO DE PARTIDO
              </a>
            </div>
          </div>
          <div className="partidos-card">
            <p className="team-text">PRIMER EQUIPO</p>
            <p className="date-text">SÁBADO 26 AGO</p>
            <div className="team-logos">
              <img src={team1} alt="PSG" className="log1" />
              <img src={team2} alt="PSG" className="log2" />
            </div>
            <h2>
              PARIS <span>VS</span> LENS
            </h2>
            <div className="score">
              <div className="match-1">3</div>
              <div className="match-2">1</div>
            </div>
          </div>
          <div className="partidos-card">
            <p className="team-text">PRIMER EQUIPO</p>
            <p className="date-text">SÁBADO 26 AGO</p>
            <div className="team-logos">
              <img src={team1} alt="PSG" className="log1" />
              <img src={team2} alt="PSG" className="log2" />
            </div>
            <h2>
              PARIS <span>VS</span> LENS
            </h2>
            <div className="score">
              <div className="match-1">3</div>
              <div className="match-2">1</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
